import axios, { AxiosResponse } from 'axios';

export const payment = {
  getPaymentAccounts: (payload): Promise<AxiosResponse> =>
    axios.get('/Payment/PaymentAccountsV2', payload),

  getUserSavedRestaurantVouchers: (storeId: number): Promise<AxiosResponse> =>
    axios.get(
      `/RestaurantVouchers/GetUserSavedRestaurantVouchers?storeId=${storeId}`,
    ),

  getUserSavedRestaurantVoucherStatus: (
    paymentAccountId: number,
    storeId: number,
  ): Promise<AxiosResponse> =>
    axios.get(
      `/RestaurantVouchers/GetUserSavedRestaurantVoucherStatus?paymentAccountId=${paymentAccountId}&storeId=${storeId}`,
    ),

  postAddUserPayGreenVoucher: (payload): Promise<AxiosResponse> =>
    axios.post('/RestaurantVouchers/AddUserPayGreenVoucher', payload),

  postCardPaymentAccount: (payload): Promise<AxiosResponse> =>
    axios.post('/Payment/CardPaymentAccount', payload),

  postCategorizeMenuitems: (payload): Promise<AxiosResponse> =>
    axios.post('/Checkout/CategorizeMenuitems', payload),
};
